import requests from '../utils/axios'

/**
 * 获取当前用户信息
 * @returns {Promise} 用户信息Promise
 */
export const getCurrentUser = async () => {
  try {
    // 验证token是否存在（逻辑不变，复用axios的requests实例）
    const wecomToken = localStorage.getItem('wecom_access_token')
    if (!wecomToken) {
      // 直接使用requests实例调用登录接口，依赖响应拦截器处理401
      const loginResponse = await requests.get('/api/v1/auth/login')

      if (
        loginResponse &&
        loginResponse.data &&
        loginResponse.data.authorize_url
      ) {
        // 跳转到授权页面
        window.location.href = loginResponse.data.authorize_url
        // 阻止后续代码执行
        return Promise.reject(new Error('正在跳转到登录页面'))
      }
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
    // 无需额外处理401，已由requests的响应拦截器统一处理
    throw error
  }
}